import { render, staticRenderFns } from "./FullCartView.vue?vue&type=template&id=5b4759a2&"
import script from "./FullCartView.vue?vue&type=script&lang=ts&"
export * from "./FullCartView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports